import { useMonthlyPayment } from "app/hooks/checkout/useMonthlyPayment";
import { useState } from "react";
import { GetStandardProductOrderResponse } from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import MonthlyPayment from "widgets/shared/monthly-payment";
import MonthlyPaymentModal from "widgets/shared/montly-payment-modal";
import { getFormattedPrice } from "../../shared/utils/getFormattedPrice";

interface StandardProductsTotalProps {
  className?: string;
  entity: GetStandardProductOrderResponse;
  hideMonthlyPayment?: boolean;
}

const StandardProductsTotal = ({
  className = "",
  entity,
  hideMonthlyPayment = false,
}: StandardProductsTotalProps) => {
  const [isMonthlyPaymentModalOpened, setIsMonthlyPaymentModalOpened] =
    useState(false);

  const rawTotalPrice = entity.totalPrice;

  const { data } = useMonthlyPayment(rawTotalPrice);
  const monthlyPayment = data?.monthlyPayment;

  const showMonthlyPayment = rawTotalPrice >= 250 && rawTotalPrice <= 10000;
  return (
    <>
      <div className={concatClassnames(className, "xl:gg-ml-auto")}>
        <Text className="gg-mb-1 gg-text-lg">Totaal incl. BTW</Text>

        <Text
          data-testid="total-price"
          className="gg-text-3xl sm:gg-text-4xl"
          bold
        >
          {getFormattedPrice(entity.payableAmount)}
        </Text>

        {showMonthlyPayment && (
          <MonthlyPayment monthlyPayment={monthlyPayment} />
        )}
      </div>

      <MonthlyPaymentModal
        isOpen={isMonthlyPaymentModalOpened}
        setIsOpen={setIsMonthlyPaymentModalOpened}
      />
    </>
  );
};
export default StandardProductsTotal;
